import { Paper, Typography, useTheme } from "@mui/material";
import { ReactSortable } from "react-sortablejs";
import { getColumnColor } from "../utilities/color";

interface IProps {
	data: any[];
	setData: (data: any[], key: string) => void;
	className?: string;
	columnKey: string;
	onChange?: () => void;
	children: any;
	index: number;
}

const Column = (props: IProps) => {
	const theme = useTheme();
	return (
		<div className={props.className ?? "min-w-[300px]"}>
			<Paper
				sx={{ background: getColumnColor(props.index)}}
				className="py-1 mb-3"
			>
				<Typography className="text-white text-center">
					{props.columnKey}
				</Typography>
			</Paper>

			<ReactSortable
				list={props.data}
				setList={(data) => {
					props.setData(data, props.columnKey);
				}}
				group="kanban"
				multiDrag
				swap
				style={{ minHeight: "400px" }}
			>
				{props.children}
			</ReactSortable>
		</div>
	);
};

export default Column;
